document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('[data-back-button]').forEach(function (link) {
    var hasHistory = window.history.length > 1;
    var sameOriginReferrer = false;

    if (document.referrer) {
      try {
        sameOriginReferrer = new URL(document.referrer).origin === window.location.origin;
      } catch (error) {
        sameOriginReferrer = false;
      }
    }

    // Only hijack the click when we know the browser can actually go back
    // to a page on this site. Otherwise leave the link's fallback href alone.
    if (hasHistory && sameOriginReferrer) {
      link.addEventListener('click', function (event) {
        event.preventDefault();
        window.history.back();
      });
    }
  });
});
